import {
	Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ElementRef,
	ChangeDetectionStrategy, ChangeDetectorRef, OnInit, OnDestroy
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { AccountType, getAccountTypeLabel, GroupDto, GroupTreeDto } from 'UvExplorerServer.Dtos.TS/Auth';
import { DirectoryGroupComponent } from '../directory-group/directory-group.component';
import { MessageService } from 'base';
import { UsersService } from '../../services/users.service';
import { DirectoryGroupsCache } from '../../services/DirectoryGroupsCache';


@Component({
	selector: 'directory-group-dialog',
	templateUrl: './directory-group-dialog.component.html'
})
export class DirectoryGroupDialogComponent implements OnInit, OnDestroy, OnChanges {

	@Input()
	public visible: boolean;

	@Input()
	public groupType: AccountType;

	@Input()
	public target: GroupDto;

	@Input()
	public domains: string[];

	@Input()
	public create: boolean;

	@Output()
	public visibleChange: EventEmitter<boolean>;

	@Output()
	public onOk: EventEmitter<GroupDto>;

	@Output()
	public onCancel: EventEmitter<any>;

	@ViewChild(DirectoryGroupComponent, { static: true })
	public group: DirectoryGroupComponent;

	private buttonClicked: boolean;

	constructor(private usersService: UsersService,
		private messageService: MessageService,
		private changeDetector: ChangeDetectorRef) {

		this.visible = false;
		this.target = null;
		this.domains = [];
		this.create = false;
		this.visibleChange = new EventEmitter<boolean>();
		this.onOk = new EventEmitter<GroupDto>();
		this.onCancel = new EventEmitter<any>();

		this.buttonClicked = false;
	}

	public ngOnInit(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {

	}

	public ngOnDestroy(): void {

	}

	public get enableOk(): boolean {
		return this.group.enableApply;
	}

	public get dialogTitle(): string {
		let operationTitle = (this.create ? "Create" : "Edit");

		let groupTypeTitle = getAccountTypeLabel(this.groupType);

		return `${operationTitle} ${groupTypeTitle} Group`;
	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);

		this.changeDetector.markForCheck();
	}

	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);

		this.changeDetector.markForCheck();
	}

	public onDialogHide(): void {
		if (this.buttonClicked) {
			this.buttonClicked = false;
		}
		else {
			this.doCancelActions();
		}
	}

	public onCancelClicked(): void {
		this.buttonClicked = true;
		this.doCancelActions();
	}

	private doCancelActions(): void {
		this.hide();
		this.onCancel.emit();
	}

	public onOkClicked(): void {
		let isUpdate = !this.create;
		if (isUpdate && !this.updateIsSafe()) {
			this.messageService.displayErrorMessage("This group cannot be removed");
		}
		else {
			this.apply();
		}
	}

	private updateIsSafe(): boolean {
		return true;
	}

	private apply(): void {
		if (this.target) {
			this.group.applyTempChanges();

			if (this.create) {
				let parentGroup: GroupDto = this.usersService.groupTree.RootGroup;
				this.usersService.createGroup(this.target, parentGroup.Guid, -1).subscribe(
					(result: GroupDto) => {
						this.buttonClicked = true;
						this.hide();
						this.onOk.emit(result);
						this.messageService.displayInfoMessage("Group successfully created");
					},
					(error) => {
						this.messageService.displayErrorMessage("Creating group failed");
					});
			}
			else {
				this.usersService.updateGroup(this.target).subscribe(
					(result: GroupDto) => {
						this.buttonClicked = true;
						this.hide();
						this.onOk.emit(result);
						this.messageService.displayInfoMessage("Group successfully updated");
					},
					(error) => {
						this.messageService.displayErrorMessage("Updating group failed");
					});
			}
		}
	}

}
